export function pluralize(
  base_word: string,
  count: number,
  suffix: string
): string {
  return count === 0 ? base_word : `${base_word}${suffix}`;
}

export function pointsText(points: number): string {
  let pointsString = "no points"
  if (points===1) {
    pointsString = `1 point`
  }
  else if (points>1) {
    pointsString = `${points} points`
  }
  return pointsString;  
}